import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const handleClick = (href: string) => {
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-50 to-primary-950/30" />
      <div className="absolute top-0 right-0 w-full md:w-1/2 h-full opacity-20 md:opacity-30">
        <div className="absolute inset-0 bg-gradient-to-l from-primary-500/20 via-accent-500/10 to-transparent" />
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full flex flex-col items-start gap-6">
            <div className="flex flex-wrap gap-2">
              {heroData.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 text-xs font-medium rounded-full bg-primary-500/15 text-primary-400 border border-primary-500/20 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-50 leading-tight tracking-tight">
              {heroData.h1}
            </h1>

            <p className="text-lg md:text-xl text-accent-400 font-medium font-heading">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-400 leading-relaxed max-w-[620px]">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center gap-6 md:gap-8">
              {heroData.statusItems.map((item) => (
                <div key={item.label} className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-accent-500" />
                  <span className="text-sm text-foreground-300">
                    <strong className="text-foreground-100 font-medium">{item.value}</strong>
                    <span className="mx-1 text-foreground-500">·</span>
                    {item.label}
                  </span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3 pt-2">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => { e.preventDefault(); handleClick(heroData.primaryCta.href); }}
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-foreground-50 font-semibold text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                {heroData.primaryCta.text}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => { e.preventDefault(); handleClick(heroData.secondaryCta.href); }}
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg border border-background-300 hover:border-background-400 text-foreground-200 hover:text-foreground-50 font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                {heroData.secondaryCta.text}
                <i className="ri-download-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] md:w-[380px] md:h-[500px] lg:w-[420px] lg:h-[540px] rounded-2xl overflow-hidden bg-background-100 border border-background-200/50">
              <img
                src={heroData.heroImage}
                alt="黑料官网 - 全网黑料视频聚合平台主视觉"
                className="w-full h-full object-cover object-top"
                title="黑料官网主视觉"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-500/80 flex items-center justify-center backdrop-blur-sm">
                  <i className="ri-play-fill text-foreground-50 text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-300">正在热播</p>
                  <p className="text-sm text-foreground-50 font-medium">热门吃瓜精选合集</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}